export default __webpack_public_path__ + "static/media/postmark.a817f968.svg";